import { createFeatureSelector, createSelector } from '@ngrx/store';
import { billingTransactionsReferencesFeatureKey } from '../reducers';
import { BillingTransactionsReferencesState } from '../reducers/billing-transactions-references.reducer';

export const selectBillingTransactionsReferences =
  createFeatureSelector<BillingTransactionsReferencesState>(
    billingTransactionsReferencesFeatureKey
  );

export const selectTransactionsReferencesByAccountNumber = (
  accountNumber: string
) =>
  createSelector(
    selectBillingTransactionsReferences,
    (state) => state.byAccountNumber[accountNumber]
  );

export const selectBillingTransactionsReferencesHasError = createSelector(
  selectBillingTransactionsReferences,
  (state) =>
    Object.keys(state.byAccountNumber).filter(
      (key) => state.byAccountNumber[key] && state.byAccountNumber[key].hasError
    ).length > 0
);
